import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MasterService } from "../../Shared/app.Masters.Service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { LmsService } from "../../_Lms/services/lms.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { DialogService } from "../../Shared/dialog.service";


declare var $: any;

@Component({
    selector: "app-vehicle-varient-master",
    templateUrl: "./vehicle-varient-master.component.html",
    styleUrls: ["./vehicle-varient-master.component.scss"],
    standalone: false
})
export class VehicleVarientMasterComponent implements OnInit {
  private data: any;
  ID: number = 0
  vehicleModelList: any[] = [];
  showSpinner: boolean = false;
  SelectModel: any = "";
  SelectManufacture: string = "";
  VehicleVariantName: string = "";
  ManufactureData: any[] = [];
  VehicleVarient: any = [];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  updateBtn: boolean = false;
  saveBtn: boolean = true;
  loading: boolean = false;
  dataVariantSource: any;
  JsonData: any[] = [];
  FilterInputSearch: string = ""; // Search filter variable
  currentUser: any;
  displayedVariantColumns: string[] = [
    "Id",
    "Vehicle_Variant_Name",
    "Manufacture",
    "Vehicle_Model_Name",
    "Action"
  ];
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  private _MasterService;

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private dialog: DialogService

  ) // private LmsService: LmsService
  {
    this._MasterService = MasterService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));

    // this._LmsService = LmsService;
  }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Vehicle Varient Master");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.LMS_Get_VehicleVariant_Master();
    //this.LMS_GetVehicleModelMaster();
    this.LMS_GetAssetInfoMaster();
  }

 
  LMS_GetVehicleModelMaster() {
    this._MasterService
      .GetVehicleModelForDropdown({ ManufactureId: this.SelectManufacture })
      .subscribe((response: any) => {
        this.vehicleModelList = Array.isArray(response) ? response : [];
        console.log("response_vehicleModelList", response);
      });
  }

 
  LMS_Get_VehicleVariant_Master() { 
    this.showSpinner = true;
    this._MasterService
      .LMS_Get_VehicleVariant_Master()
      .subscribe((response) => {
        console.log(response);
        this.JsonData = JSON.parse(JSON.stringify(response));  // Backup
        this.dataVariantSource =  new MatTableDataSource(response);
        this.dataVariantSource.paginator = this.paginator;      // Assign paginator after datasource
        this.dataVariantSource.sort = this.sort;
        this.showSpinner = false;
      });
  }

  LMS_GetAssetInfoMaster() {
    this.MasterService.GetManufactureForDropdown({}).subscribe(
      (response: any) => {
        this.ManufactureData = response;
      }
    );
  }

  openModal() {
    $("#vehicleVarientMasterModal").modal("show");
  }

  closeModal() {
    this.SelectManufacture = "";
    this.SelectModel = "";
    this.VehicleVariantName = "";

    $("#vehicleVarientMasterModal").modal("hide");
  }

  onSavevehicleVarientMaster() {
    this.showSpinner = true;
    this._MasterService
      .LMS_Save_VehicleVariant_Master({
        Id: 0,
        Vehicle_Variant_Name: this.VehicleVariantName,
        Vehicle_Model_Id: Number(this.SelectModel),
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((response: any) => {
        console.log("LMS_Save_VehicleVariant_Master_response", response);
        if (response.length > 0) {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          // this.GetData();
          this.closeModal();
          this.LMS_Get_VehicleVariant_Master();
        } else {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  editVariantInfo(row: any): void {
    this.ID = row.Id;
    this.VehicleVariantName = row.Vehicle_Variant_Name;
  
  
   this.SelectManufacture = row.Manufacture_Id?.toString() || '';
    this.SelectModel = row.Vehicle_Model_Id?.toString() || '';
  
   
    this.LMS_GetVehicleModelMaster();
  
    this.saveBtn = false;
    this.updateBtn = true;
  
    $("#vehicleVarientMasterModal").modal("show");
  }
  
  
  
  removeVariantInfo(row: any) {
    this.dialog
      .openConfirmDialog(
        `Are you sure you want to delete this Variant ${row.Vehicle_Variant_Name}?`
      )
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this._MasterService.LMS_Delete_VehicleVariant_Master({
            Id: row.Id,
            LoginUserId: this.currentUser.userId,
          }).subscribe((response: any) => {
            console.log("LMS_Delete_VehicleVariant_Masterresponse", response)
            if (response.length > 0) {
              this.showSpinner = false;
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
              this.LMS_Get_VehicleVariant_Master();
            }
          });
        }
      });
  }
  
  UpdateVarientInfo() {
    this.showSpinner = true;
    this._MasterService
      .LMS_Save_VehicleVariant_Master({
        Id: this.ID,  // Pass existing Id for Update
        Vehicle_Variant_Name: this.VehicleVariantName,
        Vehicle_Model_Id: Number(this.SelectModel),
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((response: any) => {
        console.log("Update_VehicleVariant_Response", response);
        this.showSpinner = false;
        if (response.length > 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.closeModal();
          this.LMS_Get_VehicleVariant_Master();
        }
      });
  }
  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "export_vehicle_varient"
    ) as HTMLTableElement;
    const worksheetName = "VEHICLE VARIANT"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

applyFilter(filterValue: string) {
  this.dataVariantSource.filter = filterValue.trim().toLowerCase();
}
}
